import { Flex } from '~/design_system/chakra'
import { Progress } from '~/design_system'

export const DefaultChartSkeleton = () => (
  <Flex height="full">
    <Progress
      color="lightgray"
      value={100}
      width="200px"
      height="20px"
      m="auto"
      hasStripe
      isAnimated
      alignSelf="center"
    />
  </Flex>
)
